"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
var _message = require("_l/message");
var _elementUi = require("element-ui");
var _process = require("_a/flow/process/process");
var _vuex = require("vuex");
var _user = require("@/api/admin/user/user");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'process-manage',
  components: {
    TablePage: _tablePage.default
  },
  data: function data() {
    return {
      dialogProcessPicShow: false,
      dialogApprovalShow: false,
      dialogFlowSetShow: false,
      processPicUrl: null,
      flowNodeTableData: [],
      queryParams: {},
      columns: [{
        label: '流程定义ID',
        prop: 'id',
        width: '350px'
      }, {
        label: '名称',
        prop: 'name'
      }, {
        label: '标识',
        prop: 'key'
      }, {
        label: '类别',
        prop: 'category'
      }, {
        label: '版本',
        prop: 'version',
        width: '80px'
      }, {
        label: '是否挂起',
        slot: 'suspendState',
        width: '80px'
      }, {
        label: '部署时间',
        prop: 'deploymentTime'
      }, {
        label: '操作',
        slot: 'action'
      }],
      flowNodeRow: null,
      flowNodeIndex: null,
      flowTypeOptionList: [],
      idsOptionList: [],
      optionData: [],
      loading: false
    };
  },
  watch: {
    'flowNodeRow.flowType': function flowNodeRowFlowType(newVal, oldVal) {
      console.log(oldVal);
      console.log(newVal);
      if (oldVal !== undefined && newVal !== oldVal) {
        this.flowNodeRow.ids = [];
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    seeProcessPic: function seeProcessPic(row) {
      this.dialogProcessPicShow = true;
      var time = new Date().getTime();
      this.processPicUrl = "".concat(process.env.VUE_APP_PROXY_TARGET, "flow/diagram/getPicByProcessDefinitionId?processDefinitionId=").concat(row.id, "&time=").concat(time);
    },
    update: function update(row) {
      var _this = this;
      (0, _message.ConfirmCustom)({
        type: 'warning',
        message: "\u662F\u5426\u786E\u8BA4\u6302\u8D77\u4E3A".concat(row.id, "\u7684\u6D41\u7A0B?")
      }).then(function () {
        (0, _process.hangChange)(row.id).then(function (res) {
          if (res.data) {
            _elementUi.Message.success({
              message: '操作成功'
            });
          } else {
            _elementUi.Message.error({
              message: '操作失败'
            });
          }
          // 刷新表格
          _this.refresh();
        });
      });
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this2 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning',
        message: "\u662F\u5426\u786E\u8BA4\u5220\u9664\u4E3A".concat(row.id, "\u7684\u6D41\u7A0B?")
      }).then(function () {
        (0, _process.deleteProcessByDeploymentId)(row.deploymentId).then(function (res) {
          if (res.data) {
            _elementUi.Message.success({
              message: '删除成功'
            });
          } else {
            _elementUi.Message.error({
              message: '删除失败'
            });
          }
          // 刷新表格
          _this2.refresh();
        });
      });
    },
    /**
     * 设置审批人
     * @param row
     */
    setApprovalUser: function setApprovalUser(row) {
      var _this3 = this;
      var time = new Date().getTime();
      this.processPicUrl = "".concat(process.env.VUE_APP_PROXY_TARGET, "flow/diagram/getPicByProcessDefinitionId?processDefinitionId=").concat(row.id, "&time=").concat(time);
      (0, _process.getActivityListByProDefId)(row.id).then(function (res) {
        _this3.flowNodeTableData = res.data;
        _this3.$nextTick(function () {
          this.dialogApprovalShow = true;
        });
      });
    },
    saveFlowNode: function saveFlowNode() {
      var _this4 = this;
      this.dialogApprovalShow = false;
      (0, _process.flowNodeSave)(this.flowNodeTableData).then(function (res) {
        if (res.data) {
          // 刷新表格
          _this4.refresh();
        }
      });
    },
    setUpFlow: function setUpFlow(row, index) {
      this.flowNodeRow = _objectSpread({}, row);
      this.flowNodeIndex = index;
      this.optionData = [];
      this.dialogFlowSetShow = true;
    },
    remoteMethod: function remoteMethod(query) {
      var _this5 = this;
      if (query !== '') {
        this.loading = true;
        (0, _user.getOptionDataByFlowType)(this.flowNodeRow.flowType, query).then(function (res) {
          _this5.loading = false;
          _this5.optionData = res.data;
        });
      } else {
        this.optionData = [];
      }
    },
    saveData: function saveData() {
      this.flowNodeTableData.splice(this.flowNodeIndex, 1, this.flowNodeRow);
      this.dialogFlowSetShow = false;
    }
  }),
  mounted: function mounted() {
    var _this6 = this;
    this.getDictListByType('flow_type').then(function (res) {
      _this6.flowTypeOptionList = res;
    });
  }
};